import { Component, OnDestroy, Renderer2, OnInit, NgZone, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';

import { TipoGatilho } from './seguranca/alerta/alerta-gatilho/model/gatilho/tipo-gatilho.enum';
import { IVWAlerta } from './seguranca/alerta/model/vw-alerta.interface';

import { AutenticacaoService } from './seguranca/autenticacao.service';
// import { FirebaseMessagingService } from './core/firebase/firebase-messaging.service';
import { TopbarFilterHandlerService } from './core/framework/filters/topbar-filter/service/topbar-filter-handler.service';
import { AlertaService } from './seguranca/alerta/alerta.service';
import { Notificacao } from './core/notificacao/notificacao.model';
import { NotificacaoService } from './core/notificacao/notificacao.service';
import { ConfirmacaoService } from './core/confirmacao/confirmacao.service';
import { AutoComplete } from 'primeng/autocomplete';
import { BottomPanelComponent } from './core/bottom-panel/bottom-panel.component';
import { ReleaseNoteService } from './seguranca/release-note/release-note.service';
import { Usuario } from './seguranca/usuario/usuario/usuario.model';
import { UsuarioService } from './seguranca/usuario/usuario/usuario.service';
import { ReleaseNoteFilter } from './seguranca/release-note/model/release-note.filter';
import { Status } from './core/framework/default.model';
import { ListaResultset } from './core/list/lista-resultset.interface';
import { ReleaseNote } from './seguranca/release-note/model/release-note.model';
import { ReleaseNoteHomeComponent } from './seguranca/release-note/components/release-note-home/release-note-home.component';
import { PermissaoNome } from './seguranca/perfil-de-acesso/permissao/permissao-nome.enum';
import { VersionCheckService } from './seguranca/version-check/version-check.service';


@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.css'],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy, OnInit {

  // @ViewChild('overlayPanel') overlayPanel: OverlayPanelComponent;
  @ViewChild('bottomPanel') bottomPanel: BottomPanelComponent;

  menuClick: boolean;

  menuButtonClick: boolean;

  topbarMenuButtonClick: boolean;

  topbarMenuClick: boolean;

  topbarMenuActive: boolean;

  activeTopbarItem: Element;

  layoutMode = 'static'; // overlay

  sidebarActive: boolean;

  mobileMenuActive: boolean;

  darkMenu: boolean;

  isRTL: boolean;

  rippleInitListener: any;

  rippleMouseDownListener: any;

  menuHoverActive: boolean;

  resetMenu: boolean;

  isShowMenu: boolean;
  isShowTopbar: boolean;
  isShowBreadcrumb: boolean;
  isShowFooter: boolean;

  isContentFullScreen: boolean;
  isForceHideBreadcrumb = false;

  isUsuarioLogado: boolean;

  public isShowTopbarFilter = false;

  constructor(public renderer: Renderer2,
              public zone: NgZone,
              private router: Router,
              private changeDetectorRef: ChangeDetectorRef,
              private versionCheckService: VersionCheckService,
              private autenticacaoService: AutenticacaoService,
              private releaseNoteService: ReleaseNoteService,
              private usuarioService: UsuarioService,
              // private firebaseMessagingSerice: FirebaseMessagingService,
              private topbarFilterHandlerService: TopbarFilterHandlerService,
              private alertaService: AlertaService,
              private notificacaoService: NotificacaoService,
              private confirmacaoService: ConfirmacaoService) {
              }

  ngOnInit() {
    // TODO: problema gerado com upgrade do primeng
    // https://github.com/primefaces/primeng/issues/8740
    AutoComplete.prototype.onOverlayAnimationDone = function (event: any) {
      if (event.toState === 'void') {
          //this._suggestions = null;
      }
    };

    this.zone.runOutsideAngular(() => {this.bindRipple(); });

    this.verificaUsuarioLogado();

    this.versionCheckService.initVersionCheck();
  }

  public setContentFullScreen(value: boolean): void {
    this.isContentFullScreen = value;
    this.changeDetectorRef.detectChanges();
  }

  public isTopbarFilterVisible(): boolean {
    return this.isShowTopbarFilter;
  }

  public toggleTopbarFilter(): void {
    if ( this.isShowTopbarFilter ) {
      this.hideTopbarFilter();
    }
    else {
      this.showTopbarFilter();
    }
  }

  public hideTopbarFilter(): void {
    this.isShowTopbarFilter = false;

    this.topbarFilterHandlerService.onHide();
  }

  public showTopbarFilter(): void {
    this.isShowTopbarFilter = true;

    this.topbarFilterHandlerService.onShow();
  }

  // public getOverlayPanel(): OverlayPanelComponent {
  //   return this.overlayPanel;
  // }

  public getBottomPanel(): BottomPanelComponent {
    return this.bottomPanel;
  }

  public setShowMenu(valor: boolean): void {
    this.isShowMenu = valor;
    this.changeDetectorRef.detectChanges();
  }

  public setShowBreadcrumb(valor: boolean): void {
    this.isShowBreadcrumb = valor;
    this.changeDetectorRef.detectChanges();
  }

  verificaUsuarioLogado(): boolean {
    this.isUsuarioLogado = this.autenticacaoService.usuarioEstaLogado();
    if ( this.isUsuarioLogado ) {
        setTimeout(() => {
          this.isShowTopbar = true;
          this.isShowMenu = true;
          this.isShowBreadcrumb = true;
          this.isShowFooter = true;
        }, 100);

        // setTimeout(() => {
        //   this.firebaseMessagingSerice.requestToken();
        // }, 10);

        // this.verificarProdutosVencidosEmEstoque();
        this.verificarAlertas();

        this.verificarNovasReleases();

        return true;
    } else {
        // TODO conferir se a chamada do navigate deve ficar antes dos booleans.
        this.isShowTopbar = false;
        this.isShowMenu = false;
        this.isShowBreadcrumb = false;
        this.isShowFooter = false;

        // o redirecionador foi passado pra dentro do AuthGuard
        // this.router.navigate(['login']);

        // FIXME: Por algum motivo a aplicação não está
        // realizando o logout se descomentar o Unsubscribe abaixo;
        // if ( this.firebaseMessagingSerice ) {
        //   this.firebaseMessagingSerice.unsubscribe();
        // }

        return false;
    }
  }

  bindRipple() {
      this.rippleInitListener = this.init.bind(this);
      document.addEventListener('DOMContentLoaded', this.rippleInitListener);
  }

  init() {
      this.rippleMouseDownListener = this.rippleMouseDown.bind(this);
      document.addEventListener('mousedown', this.rippleMouseDownListener, false);
  }


  rippleMouseDown(e) {
      for (let target = e.target; target && target !== this; target = target['parentNode']) {
          if (!this.isVisible(target)) {
            continue;
          }

          // Element.matches() -> https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
          if (this.selectorMatches(target, '.ripplelink, .ui-button')) {
            const element = target;
            this.rippleEffect(element, e);
            break;
          }
      }
  }

  selectorMatches(el, selector) {
      const p = Element.prototype;
      const f = p['matches'] || p['webkitMatchesSelector'] || p['mozMatchesSelector'] || p['msMatchesSelector'] || function (s) {
          return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
      };
      return f.call(el, selector);
  }

  isVisible(el) {
      return !!(el.offsetWidth || el.offsetHeight);
  }

  rippleEffect(element, e) {
      if (element.querySelector('.ink') === null) {
          const inkEl = document.createElement('span');
          this.addClass(inkEl, 'ink');

          if (this.hasClass(element, 'ripplelink') && element.querySelector('span')) {
            element.querySelector('span').insertAdjacentHTML('afterend', '<span class=\'ink\'></span>');
          } else {
            element.appendChild(inkEl);
          }
      }

      const ink = element.querySelector('.ink');
      this.removeClass(ink, 'ripple-animate');

      if (!ink.offsetHeight && !ink.offsetWidth) {
          const d = Math.max(element.offsetWidth, element.offsetHeight);
          ink.style.height = d + 'px';
          ink.style.width = d + 'px';
      }

      const x = e.pageX - this.getOffset(element).left - (ink.offsetWidth / 2);
      const y = e.pageY - this.getOffset(element).top - (ink.offsetHeight / 2);

      ink.style.top = y + 'px';
      ink.style.left = x + 'px';
      ink.style.pointerEvents = 'none';
      this.addClass(ink, 'ripple-animate');
  }

  hasClass(element, className) {
      if (element.classList) {
        return element.classList.contains(className);
      } else {
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
      }
  }

  addClass(element, className) {
      if (element.classList) {
        element.classList.add(className);
      } else {
          element.className += ' ' + className;
      }
  }

  removeClass(element, className) {
      if (element.classList) {
        element.classList.remove(className);
      } else {
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      }
  }

  getOffset(el) {
      const rect = el.getBoundingClientRect();

      return {
        top: rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
        left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0),
      };
  }

  unbindRipple() {
      if (this.rippleInitListener) {
          document.removeEventListener('DOMContentLoaded', this.rippleInitListener);
      }
      if (this.rippleMouseDownListener) {
          document.removeEventListener('mousedown', this.rippleMouseDownListener);
      }
  }

  ngOnDestroy() {
      this.unbindRipple();
  }

  onWrapperClick() {
      if (!this.menuClick && !this.menuButtonClick) {
          this.mobileMenuActive = false;
      }

      if (!this.topbarMenuClick && !this.topbarMenuButtonClick) {
          this.topbarMenuActive = false;
          this.activeTopbarItem = null;
      }

      if (!this.menuClick) {
          if (this.isHorizontal() || this.isOverlay()) {
              this.resetMenu = true;
          }

          this.menuHoverActive = false;
      }


      this.menuClick = false;
      this.menuButtonClick = false;
      this.topbarMenuClick = false;
      this.topbarMenuButtonClick = false;
  }

  onMenuButtonClick(event: Event) {
      this.menuButtonClick = true;

      if (this.isMobile()) {
          this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
  }

  onTopbarMobileMenuButtonClick(event: Event) {
      this.topbarMenuButtonClick = true;
      this.topbarMenuActive = !this.topbarMenuActive;
      event.preventDefault();
  }

  onTopbarRootItemClick(event: Event, item: Element) {
      if (this.activeTopbarItem === item) {
          this.activeTopbarItem = null; } else {
          this.activeTopbarItem = item; }

      event.preventDefault();
  }

  onTopbarMenuClick(event: Event) {
      this.topbarMenuClick = true;
  }

  onSidebarClick(event: Event) {
      this.menuClick = true;
      this.resetMenu = false;
  }

  onToggleMenuClick(event: Event) {
      this.layoutMode = this.layoutMode !== 'static' ? 'static' : 'overlay';
      event.preventDefault();
  }

  isMobile() {
      return window.innerWidth <= 1024;
  }

  isTablet() {
      const width = window.innerWidth;
      return width <= 1024 && width > 640;
  }

  isHorizontal() {
      return this.layoutMode === 'horizontal';
  }

  isOverlay() {
      return this.layoutMode === 'overlay';
  }

  verificarProdutosVencidosEmEstoque(): void {
    setTimeout(() => {
      this.alertaService.listarProdutosVencidos()
                        .subscribe(itens => {
                          if ( itens && itens.length > 0 ) {
                            const texto = 'Existem produtos vencidos no estoque!';
                            const notificacao = new Notificacao();
                            notificacao.setTitulo(texto);
                            notificacao.setOnClick(() => {
                              this.confirmacaoService
                                  .confirmarTextoSimples('Ir para o estoque?',
                                                        () => this.router.navigate(['/farmacia/entrada-de-produto/item-estoque']));
                            });
                            this.notificacaoService.adicionarNotificacao(notificacao);
                            // NotificacaoService.criarNotificacaoTexto(texto);
                          }
                        });
    }, 300);
  }

  private intervalListarAlertas = null;
  verificarAlertas(): void {
    const temPermissao = this.usuarioService.usuarioLogadoTemPermissao(PermissaoNome.ROLE_PESQUISAR_ALERTA);
    if ( !temPermissao ) {
      return;
    }

    setTimeout(() => {
      this.alertaService.listarAlertas().subscribe(itens => this.notificarAlertas(itens));
    }, 300);

    if ( this.intervalListarAlertas ) {
      clearInterval(this.intervalListarAlertas);
    }

    this.intervalListarAlertas = setInterval(() => {
      this.alertaService.listarAlertas()
                        .subscribe(itens => {
                          this.notificarAlertas(itens);
                        });
    }, 1000 * 60 * 60);
  }

  notificarAlertas(itens: IVWAlerta[]): void {
    if ( itens && itens.length > 0 ) {
      this.notificacaoService.limparNotificacao();
      for (const alerta of itens) {
        const notificacao = new Notificacao();
        const tipoGatilho = TipoGatilho[alerta.tipoGatilho];
        const tipo = tipoGatilho === TipoGatilho.DIAS_PROX_VENCIMENTO ? 'Próximo do vencimento: '
          : tipoGatilho === TipoGatilho.QUANT_MINIMA_ESTOQUE ? 'Quantidade mínima em estoque: '
          : tipoGatilho === TipoGatilho.QUANT_MINIMA_INVENTARIO ? 'Quantidade mínima no setor: '
          : '';
        notificacao.setTitulo(tipo + alerta.descricao);
        this.notificacaoService.adicionarNotificacao(notificacao);
      }
    }
  }

  verificarNovasReleases(): void {
    setTimeout(() => {
      const temPermissaoPraVerRelease = this.usuarioService.usuarioLogadoTemPermissao(PermissaoNome.ROLE_PESQUISAR_RELEASE_NOTE);
      if ( !temPermissaoPraVerRelease ) {
        return;
      }

      const usuarioLogado: Usuario = UsuarioService.getUsuarioFromLocalStorage();

      const filter: ReleaseNoteFilter = {
        status: Status.ATIVO,
        publicado: true,
        idUsuarioLeitor: usuarioLogado.id
      };

      this.releaseNoteService
          .listar(filter)
          .subscribe((response: ListaResultset<ReleaseNote>) => {
            const releaseNotes: ReleaseNote[] = response.content;
            if ( releaseNotes.length === 1 ) {
              this.router.navigate(['/seguranca/configuracao/release-note', releaseNotes[0].id])
            }
            else if ( releaseNotes.length > 1 ) {
              this.router.navigate([ReleaseNoteHomeComponent.releaseNoteHomeUri])
            }
          });
    }, 1);
  }
}
